import { gql } from "@apollo/client";

export const CREATE_MONITOR_EXCLUSION = gql`
  mutation createMonitorExclusion(
    $input: CreateMonitorReferenceExclusionInput!
  ) {
    aml {
      createMonitorReferenceExclusion(input: $input) {
        id
        success
      }
    }
  }
`;
